import { getApi } from '../api/storeFront';
const getMetaInfo = async (type, title, logger) => {
    const path = type && title ? `?type=${type}&title=${title}` : type && !title ? `?type=${type}` : '';
    return getApi(`/metainfo${path}`, logger);
};
export default getMetaInfo;
